export const CONSTANTS_MESSAGE = {
    DEFAULT_MESSAGE_ERROR:'Occurrió un error, por favor intentelo de nuevo más tarde',
    TYPE_ERROR: 'error',
    TYPE_SUCCESS: 'success',
    TYPE_INFO: 'info',
    TYPE_WARNING: 'warning',
};